import { useLocale } from "../i18n/LocaleContext";

interface DateTilesProps {
  dates: string[];
}

interface ParsedDate {
  iso: string;
  date: Date;
}

function parseIsoDate(iso: string): ParsedDate | null {
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return null;
  return { iso, date };
}

const DateTiles = ({ dates }: DateTilesProps) => {
  const { locale, t } = useLocale();

  const parsed = dates
    .map(parseIsoDate)
    .filter((d): d is ParsedDate => d !== null)
    .sort((a, b) => a.date.getTime() - b.date.getTime());

  if (parsed.length === 0) {
    return <p>{t.detail.datesEmpty}</p>;
  }

  const monthFmt = new Intl.DateTimeFormat(t.localeTag, { month: "short" });
  const yearFmt = new Intl.DateTimeFormat(t.localeTag, { year: "numeric" });

  return (
    <ul className="date-tiles" aria-label={t.detail.dates}>
      {parsed.map(({ iso, date }) => (
        <li key={iso} className="date-tile">
          <span className="date-tile__month">{monthFmt.format(date)}</span>
          <span className="date-tile__day">{date.getDate()}</span>
          <span className="date-tile__year">{yearFmt.format(date)}</span>
        </li>
      ))}
    </ul>
  );
};

export default DateTiles;
